<div class="ipm-common-banner" [class.ipm-container]="isAddContainer">
    <ngx-slick-carousel class="carousel" 
                        #slickModal="slick-carousel"
                        [config]="slideConfig"
                        [id]="id">
        <div ngxSlickItem *ngFor="let imgObj of imageArray" class="slide">
            <figure class="ipm-image-container" (click)="onSliderBannerClick(imgObj.routerTo)"> 
                <picture>
                    <source media="(max-width: 767px)" [srcset]="imgObj?.mobileImage">
                    <source media="(max-width: 865px)" [srcset]="imgObj?.mobileImage">
                    <img [src]="imgObj?.desktopImage" alt="banner-image" loading="lazy">
                </picture>
            </figure>
        </div>
    </ngx-slick-carousel>
</div>


